import httpService from 'services/httpService';

export const revokeOrcidID = async (userId: string) => {
  try {
    return await httpService.get({
      url: `/auth-gateway/SSO/orcid/revoke/token/${userId}`,
      includeAuth: true
    });
  } catch (err) {}
};

export const linkOrcid = async (
  userId: string,
  email?: string,
  callback?: (isSuccessful: boolean) => void
) => {
  try {
    const windowObject = window.open(
      `/api/auth-gateway/SSO/link-profile/orcid?action=link&userId=${userId}&email=${email}`
    );

    window?.addEventListener('message', ({ data }) => {
      const { message = '', error_code = '' } = data;
      if (message === 'Sign in successful') callback?.(true);
      if (Number(error_code) >= 400) callback?.(false);
    });
  } catch (err) {
    callback?.(false);
  }
};

export const sendForgotPasswordEmail = (email: string) => {
  return httpService.post({
    url: `/auth-gateway/auth/forgot-password`,
    data: { email }
  });
};
